import React, { useRef, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgetPassword } from "../../redux/actions/authAction";
import Blinking from "../../Loaders/Blinking";

export default function ResetPassword(props) {
  const { forgetPasswordRes, isForgetPasswordStarted, isAuthenticated } = useSelector((state) => state.authData);
  const dispatch = useDispatch();
  let form = useRef();
  const handleSubmit = (e) => {
    e.preventDefault();
    const { email } = form.current;
    let formdata = { email: email.value};
    dispatch(forgetPassword(formdata));
  };

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/customers");
    }
  }, [isAuthenticated]);

  return (
    <>
    {forgetPasswordRes && forgetPasswordRes.hasOwnProperty("id") && forgetPasswordRes.id !== null ? (
        <Redirect to="/change-password" />
      ) : null}
    <div className="container-fluid userservice_section">
      <div className="row align-items-center">
        <div className="col-sm-12 login_part">
          <div className="clearfix registeraArea loginArea">
           
            <h1 className="form_title">RESET PASSWORD</h1>
            <form action="" className="form" ref={form} onSubmit={handleSubmit}>
            <p className="text-center d-block emailDesc">Enter your email address below and <br /> We’ll send
            you a PIN to reset your password</p>
              <div className="form-group">
                <label className="user_form_label">Email address</label>
                <input
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  className="form-control"
                  placeholder="Enter email address"
                  required
                  name="email"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-dark submit-btn">
                  Send password reset link {isForgetPasswordStarted && (
                    <Blinking />
                  )}
                </button>
              </div>
              <div className="form-group">
                <p className="termsAndService bold">
                  <span className="clearfix">
                    <span className="float-left">
                      <label className="i_agree">
                        <input type="checkbox" />
                        <samp className="customcheckbox"></samp>
                        <span>Remember Me</span>
                      </label>
                    </span>
                    <span className="float-right">
                      <Link to="/login">
                        Login
                      </Link>
                    </span>
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
